import { bindable, customElement } from 'aurelia-framework';

@customElement('four-decimal-render')
export class FourDecimalRender {
  @bindable()
  params;

  @bindable()
  cssClass = 'ag-grid-cell-right';

  value: any;

  bind() {
    this.value = this.params.value;
  }
}
